import anime from 'animejs/lib/anime.es.js';
import { object } from "../helpers/object";
import { debug } from "../helpers/debug";

/*------------------------------------*\
  #COUNTER

  Class gestion des element [data-js-component="counter"]

  [data-js-component="counter"]
\*------------------------------------*/
class Counter {

  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;

    this.counterInit();
    this.scrollEvents();

    if(debug.DEBUG) console.log('async/counter.js');
  }
  counterAnimation = (element) => {
    let targets = element.querySelector('[data-js-trigger="counter"]');
    let max = element.getAttribute('data-js-counter-value');
    anime({
      targets,
      innerHTML: [0, max],
      easing: 'linear',
      round: max % 1 != 0 ? 10 : 1, // Will round the animated value to 1 decimal
    });
  };
  counterInit = () => {
    const regex = /\d+(\.?\d*)?/g;
    this.DOM_MODULE.forEach(element => {
      const target = element.querySelector('[data-js-counter-target]');
      const value = target?.innerText;
      if (!value) return;
      const number = value.match(regex)?.join('');
      if (!number) return;
      element.setAttribute('data-js-counter-value', number);
      target.innerHTML = value.replace(number, `<span data-js-trigger="counter">0</span>`);
    });
  };
  scrollEvents = () => {
    this.DOM_MODULE.forEach(element => {
      const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
        this.counterAnimation(entry.target);
        observer.unobserve(entry.target);
        }
      });
      }, { threshold: 0.1 });
      observer.observe(element);
    });
  }

}
export default new Counter('[data-js-component="counter"]'); 